import React, { useEffect, useRef, useState } from "react";
import { Grid, TextField } from "@mui/material";
import ModalComponent from "../../../components/modals";
import LaddaButton from "../../../components/buttons/laddaButton";
import {
  callApiAsync,
  getCallVerifySerie
} from "../../../services/apiService";
import ToastNotification from "../../../components/toastNotification";

const AddSerieNumber = ({
  open,
  close,
  setSerieIdSelected,
  setSerieSelected,
  onStart,
  onFinish
}) => {
  const actionRef = useRef("idle");
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    if (open || actionRef.current !== "closing") return;
    actionRef.current = "idle";
    setIsSubmitting(false);
    onFinish?.();
  }, [open, onFinish]);
  const [newSerieNumber, setNewSerieNumber] = useState("");
  const [inputError, setInputError] = useState("");
  const [showToast, setShowToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");

  useEffect(() => {
    if (!open) return;

    setNewSerieNumber("");
    setInputError("");
  }, [open]);

  const handleClose = () => {
    if (actionRef.current !== "idle") return;
    finishClose();
  };

  const finishClose = () => {
    setNewSerieNumber("");
    setInputError("");
    close();
  };

  const handleChangeSerieNumber = (event) => {
    const nextValue = event.target.value;
    setNewSerieNumber(nextValue);

    if (String(nextValue).trim()) {
      setInputError("");
    }
  };

  const onSubmitNewSerie = async (event) => {
    event.preventDefault();
    event.stopPropagation();
    if (actionRef.current !== "idle") return;

    const normalizedSerieNumber = String(newSerieNumber || "").trim();

    if (!normalizedSerieNumber) {
      setInputError("Este campo es obligatorio");
      return;
    }

    if (onStart && !onStart()) return;
    actionRef.current = "running";
    setIsSubmitting(true);
    try {
      await callApiAsync(
        () => getCallVerifySerie(normalizedSerieNumber),
        (data) => {
          if (data.id === 0) {
            setSerieIdSelected(data.id);
            setSerieSelected(normalizedSerieNumber);
            actionRef.current = "closing";
            finishClose();
          } else {
            setToastMessage("Numero de serie ya existe.");
            setShowToast(true);
          }
        }
      );
    } finally {
      if (actionRef.current === "running") {
        actionRef.current = "idle";
        setIsSubmitting(false);
        onFinish?.();
      }
    }
  };

  return (
    <div>
      <ToastNotification
        severity="error"
        summary={toastMessage}
        detail=""
        showToast={showToast}
        setShowToast={setShowToast}
      />

      <ModalComponent
        open={open}
        handleClose={handleClose}
        title={""}
        actions={<div className="HContainer j-center w-complete"></div>}
      >
        <div className="HContainer">
          <form className="VContainer align-center m-20" onSubmit={onSubmitNewSerie}>
            <Grid container rowSpacing={2}>
              <Grid item xs={12}>
                <p className="create-label">Nuevo Nro. de Serie:</p>
                <TextField
                  value={newSerieNumber}
                  onChange={handleChangeSerieNumber}
                  variant="outlined"
                  fullWidth
                  autoFocus
                  disabled={isSubmitting}
                  error={Boolean(inputError)}
                  helperText={inputError}
                  inputProps={{ maxLength: 255 }}
                />
              </Grid>
            </Grid>
            <LaddaButton
              width={"180px"}
              fontSize={"12px"}
              height={"32px"}
              variant="contained"
              margin={"20px 0"}
              type="submit"
              loading={isSubmitting}
              disabled={isSubmitting || !String(newSerieNumber).trim()}
            >
              <p className="button_text">Crear Nro de Serie</p>
            </LaddaButton>
          </form>
        </div>
      </ModalComponent>
    </div>
  );
};

export default AddSerieNumber;
